<template lang="pug">
modal#set-owner-user-modal(
  :buttonColor='true'
  :close-button-label='$t("button.cancel")'
  :loading='loading'
  :process-button-label='processButtonLabel'
  :title='title'
  @process='handleProcess'
  ref='modal'
)
  .span.text {{ message }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import UsersService from '@/modules/business/services/http/organizations/users/UsersService';

export default {
  name: 'SetOwnerUserModal',
  props: {
    userId: [Number, String],
    isOwner: Boolean,
  },
  components: {
    Modal,
  },
  computed: {
    title() {
      return this.isOwner
        ? this.$t('modal.removeOwnerUser.title')
        : this.$t('modal.makeOwnerUser.title');
    },
    message() {
      return this.isOwner
        ? this.$t('modal.removeOwnerUser.message')
        : this.$t('modal.makeOwnerUser.message');
    },
    processButtonLabel() {
      return this.isOwner
        ? this.$t('button.remove')
        : this.$t('modal.makeOwnerUser.processButtonLabel');
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleProcess() {
      this.loading = true;
      try {
        if (this.isOwner) {
          await UsersService.revokeOwner(this.userId);
        } else {
          await UsersService.becomeOwner(this.userId);
        }
        this.closeModal();
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.$emit('refresh');
      this.$refs.modal.close();
    },
  },
};
</script>
